import React from 'react'

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';

const Tags = ({inputRef, name = "tag", defaultTags}) => {
    const [values, setValues] = React.useState(defaultTags || [])
    const [tagValue, setTagValue] = React.useState('')
	const handleAddTag =(event) =>{
		if (event.key === 'Enter' && tagValue.trim() !== ''){
			event.preventDefault()
			!values.includes("tagValue") && setValues([...values, tagValue])
			setTagValue('')
		}
	}
	const handleDeleteTag = (tag) =>{
        if(values.length == 1)
            setValues([])
        else
		    setValues(values.filter(t => t !== tag))
	}
    const value = values && values.length?values.join(","):""
    return(
        <Box>
            <TextField
                variant="outlined"
                label="Sufijos"
                value={tagValue}
                onChange={(e) => setTagValue(e.target.value)}
                onKeyDown={handleAddTag}
                fullWidth
            />
            <Box mt={2} display="flex" flexWrap="wrap" gap={1}>
                {values.map((tag, index) => (
                    <Chip
                        key={index}
                        label={tag}
                        onDelete={() => handleDeleteTag(tag)}
                        deleteIcon={<CloseIcon />}
                    />
                ))}
            </Box>
            <Box ref={inputRef} sx={{ display: 'none' }}><TextField name={`tag-${name}`}  value={value}/></Box>
        </Box>
    )
}

export default Tags